import React from 'react';

import {GridViewImage} from './GridViewImage.jsx';
import {GridViewActiveButton} from './GridViewActiveButton.jsx';
import {GridViewActivateButton} from './GridViewActivateButton.jsx';

var GridTheme = React.createClass({
  makeActive: function(slug){
    this.props.makeActive(slug);
  },
  showPreview: function(user, slug){
    this.props.showPreview(user, slug);
  },
  editTheme: function(slug, accountSlug, type){
    this.props.editTheme(slug, accountSlug, type);
  },
  popup: function(value){
    this.props.popup(value);  //for popup, if click on activate(in future)
  },
  render: function(){
    var layoutclass = "", showPreviwButton;
      if(this.props.themes != undefined){
        var themes = this.props.themes.map(function(value,index){
          var accountSlug = value["name"].split("/")[0];
          var slug = value["name"].split("/")[1];
          if(value["type"] == "VIEWLAYOUT")
          {
            layoutclass = "one_fifth-xl one_fourth-lg one_third-md one_half theme-grid layout__library";
            showPreviwButton = false;
          }
          else{
            layoutclass = "one_fifth-xl one_fourth-lg one_third-md one_half theme-grid";
            showPreviwButton = true;
          }
          if(this.props.active == value["name"]){
            return(
                <article className="one_fifth-xl one_fourth-lg one_third-md one_half theme-grid active" key = {index}>
                <div className="theme-grid__detail">
                  <GridViewImage  value = {value} 
                                  showPreview = {this.showPreview}
                                  editTheme = {this.editTheme}
                                  libName = {this.props.libName}
                                  showPreviwButton = {showPreviwButton}
                                  active = {this.props.active} />
                  <div className="theme-grid__title">
                    <h3>{slug}</h3>
                    <h4>by: {accountSlug}</h4>
                  </div>
                  <GridViewActiveButton value = {value} />
                </div>
              </article>
          );
        }
        else{
          return(
              <article className={layoutclass} key = {index}>
                <div className="theme-grid__detail">
                 <GridViewImage value = {value} 
                                showPreview = {this.showPreview}
                                editTheme = {this.editTheme}
                                libName = {this.props.libName}
                                showPreviwButton = {showPreviwButton}
                                active = {this.props.active} />
                  <div className="theme-grid__title">
                    <h3>{slug}</h3>
                    <h4>by: {accountSlug}</h4>
                  </div>
                  <GridViewActivateButton value = {value}
                                          makeActive = {this.makeActive}
                                          popup = {this.popup} />
                </div>
              </article>
          );
        }
      },this);
    }
    return(
        <div>
          {themes}
        </div>
      );
  }
});

export {GridTheme};


/** WEBPACK FOOTER **
 ** ./html/components/GridTheme.jsx
 **/